import { render, staticRenderFns } from "./RoyCircle.vue?vue&type=template&id=23d46aaa&"
import script from "./RoyCircle.vue?vue&type=script&lang=js&"
export * from "./RoyCircle.vue?vue&type=script&lang=js&"
import style0 from "./RoyCircle.vue?vue&type=style&index=0&id=23d46aaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports